// extracted by mini-css-extract-plugin
export default {"container":"shippingPage_container__9WV65"};